import axios from "axios";
import { closeTab, sendMessage } from "../context/utils";
import { redirectUrl } from "./constants";

export const handleOzowZarRedirect = async (payData: any, merchantKey: string, onShowAlert: (error: any, message: string) => void) => {
    
    try {

        const payload = {
            ...payData.kit,
            paymentType: payData.kit?.paymentType || 'html-checkout',
            productType: payData.kit?.productType ?? "COLLECTION",
            redirect_url: redirectUrl
        }

        const response = await axios(
            `${process.env.REACT_APP_API_URL}pay/ZAR/banktransfer/v2`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    "x-auth-token": merchantKey,
                    ...(process.env.REACT_APP_DASHBOARD_ACCESS_TOKEN && {
                        "x-fe-token": process.env.REACT_APP_DASHBOARD_ACCESS_TOKEN
                    })
                },
                data: payload,
            }
        );

        const paymentAuthorization = response.data?.data?.meta?.authorization

        if (paymentAuthorization?.mode === 'redirect') {
            const newTab = window.open(paymentAuthorization?.redirect, '_blank');
            if (newTab) {
                newTab.opener = null;
            }
            setTimeout(() => {
                closeTab(); 
            }, 100); 
        } else {
            onShowAlert?.("error", "Error redirecting to third-party. Try again later.")
            sendMessage({ status: "ERROR", tnxRef: payData.kit.tx_ref });
        }

    } catch (error) {
        onShowAlert?.(error, "Error redirecting to third-party. Try again later.")
        setTimeout(() => {
            sendMessage({ status: "ERROR", tnxRef: payData.kit.tx_ref });
        }, 1000);
    }
}

export const isValidString = (value: any): boolean => {
    return typeof value === 'string' && value.trim().length > 0;
}

export const extractRedirectionLink = (responseData: any) => {
    const responseDataObj = responseData ?? {}
    const paymentAuth = responseDataObj?.data?.meta?.authorization

    if (paymentAuth && typeof paymentAuth === "object" && paymentAuth.mode === 'redirect' && isValidString(paymentAuth.redirect)) {
        return paymentAuth.redirect;
    }

    const status = responseDataObj?.status;
    if (status === "pending" && isValidString(responseDataObj?.redirect_url)) {
        return responseDataObj.redirect_url;
    }

    return null;
}